<template>
  <EventHorizontalProductShowcase
    v-if="products.length || pending"
    :products="products"
    :pending="pending"
    :title="similarEventsTitle"
    :gtm-item-list-id="GtmItemListId.EventPageSimilarClasses"
    algolia-insights-label="Similar Events - Event Page"
    data-test-id="similar-events"
    :loader-products-count="products.length || 6"
  />
</template>

<script setup lang="ts">
import { GtmItemListId } from '~/composables/useKftGtm/types'

const {
  isGiftcard,
  displayMode = 'rest',
} = defineProps<{
  isGiftcard: boolean
  displayMode?: 'rest' | 'all'
}>()

const { restSimilarEvents, allSimilarEvents, pending } = useEventSimilarEvents()
const similarEventsTitle = useSimilarEventsTitle(isGiftcard)

const products = computed(() =>
  displayMode === 'all' ? allSimilarEvents.value : restSimilarEvents.value
)
</script>
